/**
 * Método que retorna el index del concepto de pago dentro del catálogo conceptos de pago
 * @param {Number} idConcepto 
 * @param {Array<object>} conceptoPagos 
 * @returns Number
 */
export const buscarConceptoPagosIndex = (idConcepto, conceptoPagos) => {
    const lista = conceptoPagos === undefined ? [] : [...conceptoPagos];
    for (let i = 0; i < lista.length??[]; i++) {
        if (Number(idConcepto) === lista[i]?.idConceptoPago) return i;
    }
    return 0;
}